import React from 'react';

const StripedTableCell = ({
    id = 'striped-table-cell',
    index = 0,
    evenStyle,
    oddStyle,
    border = '1px solid rgb(215,215,215)',
    activeBorder,
    isNextRowActive = false,
    disabled = false,
    scrollPx = 0,
    isHighlighted = false,
    onHover,
    highlightAlpha = 0.15,
    ...props
}) => {
    const hoverEvents = {};
    if (typeof onHover === 'function') {
        hoverEvents.onMouseOver = () => onHover(index);
        hoverEvents.onMouseLeave = () => onHover(-1);
    }
    border = isHighlighted ? '1px solid #b9d7d7' : border;
    const backgroundColour = isHighlighted
        ? '#dcffff'
        : index % 2
        ? 'rgb(247,247,247)'
        : 'rgb(255,255,255)';
    return (
        <td
            {...props}
            id={id}
            style={{
                padding: 0,
                borderBottom:
                    activeBorder &&
                    ((!disabled && !isHighlighted) || isNextRowActive)
                        ? activeBorder
                        : border,
                borderRight: border,
                position: 'relative',
                bottom: scrollPx,
                boxSizing: 'border-box',
                ...props.style,
                backgroundColor: backgroundColour,
                ...(index % 2
                    ? {
                          ...evenStyle
                      }
                    : {
                          ...oddStyle
                      })
            }}
            {...hoverEvents}
        />
    );
};

export default StripedTableCell;
